<div class="chart">
  <div [id]="idChart" class="w-100"></div>
</div>
